/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import React from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import $ from 'jquery';
import { SelectedFilterTag } from '../../admin/react/selected-filter-tag.js.jsx';

// Handles a multi-valued input, where each value is presented as a token bubble.
//
// Also supports being hooked up to a jquery autocomplete
export class TokenInput extends React.Component {
  static propTypes = {
    items: PropTypes.array,
    autocompleteSuggestURL: PropTypes.string,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    onItemAdded: PropTypes.func,
    onItemRemoved: PropTypes.func,
    isSubmittedString: PropTypes.bool,
    id: PropTypes.string
  };

  static defaultProps = {
    items: [],
    autocompleteSuggestURL: null,
    name: 'tags',
    placeholder: 'Type something and press Enter',
    onItemAdded: null,
    onItemRemoved: null,
    isSubmittedString: true
  };

        constructor(props) {
          super(props);
          this._isItemSelected = this._isItemSelected.bind(this);
          this.onTagSelect = this.onTagSelect.bind(this);
          this.onInputKeyPress = this.onInputKeyPress.bind(this);
          this._setInputRef = this._setInputRef.bind(this);
this._setWrapperRef = this._setWrapperRef.bind(this);

          this.state =
            {items: props.items};
        }

        // If the props change, reset the
        UNSAFE_componentWillReceiveProps(nextProps) {
          if (this.props.items !== nextProps.items) {
            return this.setState({items: nextProps.items});
          }
        }


        // Initialize autocomplete here, if it's requested
        componentDidMount() {
          return this.autocompleter = Slzr.MultiTagAutocomplete(this.inputEl, this.props.autocompleteSuggestURL, {
            onSelect: this.onTagSelect,
            attachTo: this.wrapperEl,
            resizeMenu: element => {
              return element.outerWidth($(this.wrapperEl).outerWidth());
            }
          }
          );
        }

        // Remove autocomplete here, if it's requested
        componentWillUnmount() {
          return this.autocompleter.destroy();
        }

        // Return true if +value+ is in the current selection
        //
        // Value can be either a string or an object with {label, value}. It will match either strings or objects
        // in the current list with a matching value (either the string, or from the value property)
        _isItemSelected(value) {
          const my = this;
          const new_value = my.valueFromItem(value);
          return _.any(this.state.items, item => my.valueFromItem(item) === new_value);
        }

        // Tag selected from dropdown
        onTagSelect(value) {
          if (!this._isItemSelected(value)) {
            const new_items = this.state.items.slice();

            if (this.props.isSubmittedString || (typeof(value) === 'object')) {
              new_items.push(value);
            } else {
              const new_value = {label: value, value, new: true};
              new_items.push(new_value);
            }

            $(this.inputEl).trigger('slzr:token:change');
            this.setState({items: new_items});
            if (typeof this.props.onItemAdded === 'function') {
              this.props.onItemAdded(value, new_items);
            }
          }

          return true;
        }

        // Override enter key presses in the input field to add the current item
        onInputKeyPress(event) {
          if (event.key === 'Enter') {
            const trimmed_value = event.target.value.trim();
            if (trimmed_value !== '') {
              this.onTagSelect(trimmed_value);
              event.target.value = '';

              // Hide the autocomplete
              $(event.target).data('ui-autocomplete').close();
            }

            return event.preventDefault();
          }
        }

        // Remove an item from the index
        onRemoveItem(index, event) {
          event.preventDefault();

          // Modify a copy of the items array
          $(this.inputEl).trigger('slzr:token:change');
          const new_items = this.state.items.slice();
          new_items.splice(index, 1);
          if (typeof this.props.onItemRemoved === 'function') {
            this.props.onItemRemoved(this.state.items[index], new_items);
          }
          return this.setState({items: new_items});
        }
      
        listFromItems() {
          // render hidden comman delimited list param
          const selected_item_list = (Array.from(this.state.items).map((item) => (item.indexOf(',') !== -1 ? `"${  this.valueFromItem(item)  }"` : this.valueFromItem(item)))).join(', ');
          return <input type="hidden" name={this.props.name} readOnly={true} value={selected_item_list} />;
        }
      
        arrayFromItems() {
          // render hidden array param
          return (() => {
            const result = [];
            for (let index = 0; index < this.state.items.length; index++) {
              var name;
              const item = this.state.items[index];
              if (item.hasOwnProperty("new")) {
                // Create a hash in the array params called new_records that sets
                // key to the index of the item and
                // value to the name of the item
                name = `${this.props.name  }[new_records][]`;
                result.push(<input type="hidden" key={index} name={name} readOnly={true} value={this.labelFromItem(item)} />);
              } else {
                result.push(<input type="hidden" key={index} name={this.props.name} readOnly={true} value={this.valueFromItem(item)} />);
              }
            }
            return result;
          })();
        }

        labelFromItem(item) {
          if (typeof(item) === 'string') {
            return item;
          } 
            return item.label;
          
        }
      
        valueFromItem(item) {
          if (typeof(item) === 'string') {
            return item;
          } 
            return item.value;
          
        }

        _setInputRef(element) { return this.inputEl = element; }
        _setWrapperRef(element) { return this.wrapperEl = element; }
      
        render() {        
          const selected_items = Array.from(this.state.items).map((item, index) =>
            <SelectedFilterTag
              key={item.value}
              onRemove={this.onRemoveItem.bind(this, index)}
              name={this.labelFromItem(item)}
            >
              {this.labelFromItem(item)}
            </SelectedFilterTag>);

          const hidden_fields = this.props.isSubmittedString ?
            this.listFromItems()
          :
            this.arrayFromItems();
        
          return <div className="form-input-token" ref={this._setWrapperRef}>
            <div className="tag_list picked_item_inline">
              {selected_items}

              <input type="text"
                     className="tag_input"
                     ref={this._setInputRef}
                     onKeyPress={this.onInputKeyPress}
                     placeholder={this.props.placeholder}
                     id={this.props.id} />
            </div>

            {hidden_fields}
          </div>;
        }
}
